export const ALERTS = {
	PRICE_COMPARISON: "Price Comparison",
	NO_AVAILABILITY: "Not Available",
	PRICE_CHANGE: "Price Change",
	MIN_MAX_PRICE: "Min & Max Price",
	RATING: "Rating",
}